function ThumbsDownIcon({ color = 'currentColor', height = '24', width = '24' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path d="M6 3H17V16L10 23L8.75 21.75C8.63333 21.6333 8.5375 21.475 8.4625 21.275C8.3875 21.075 8.35 20.8833 8.35 20.7V20.35L9.45 16H3C2.46667 16 2 15.8 1.6 15.4C1.2 15 1 14.5333 1 14V12C1 11.8833 1.01667 11.7583 1.05 11.625C1.08333 11.4917 1.11667 11.3667 1.15 11.25L4.15 4.2C4.3 3.86667 4.55 3.58333 4.9 3.35C5.25 3.11667 5.61667 3 6 3ZM15 5H6L3 12V14H12L10.65 19.5L15 15.15V5ZM17 16V14H20V5H17V3H22V16H17Z" fill={color} />
    </svg>
  );
}
export default ThumbsDownIcon;
